'use client';

import { useState } from 'react';
import { usePathname } from 'next/navigation';

import { Button } from '@/elements/button/button.component';
import { Container, Tag } from './tags.elements';

const Tags = ({ tags: initTags, onTagClick, activeTag }) => {
  const pathname = usePathname();
  const primaryTags = initTags.filter((t) => t.primary === true);

  const [tags, setTags] = useState(primaryTags.length > 0 ? primaryTags : initTags);

  const handleLoadAllTags = () => {
    setTags(initTags);
  };

  return (
    <Container>
      <Tag
        onClick={() => (activeTag !== null ? onTagClick(null) : null)}
        $active={activeTag === null}
      >
        Sve
      </Tag>
      <Tag
        onClick={() => (activeTag !== 'featured' ? onTagClick('featured') : null)}
        $active={activeTag === 'featured'}
      >
        Izdvojeno
      </Tag>
      {!pathname?.includes('moj-profil') && (
        <Tag
          onClick={() => (activeTag !== 'discount' ? onTagClick('discount') : null)}
          $active={activeTag === 'discount'}
        >
          POPUST
        </Tag>
      )}
      {tags.map(({ name, slug }) => (
        <Tag
          key={slug}
          onClick={() => (activeTag !== slug ? onTagClick(slug) : null)}
          $active={activeTag === slug}
        >
          {name.charAt(0).toUpperCase() + name.slice(1)}
        </Tag>
      ))}
      {tags.length !== initTags.length ? (
        <Button naked style={{ fontSize: '0.9rem' }} onClick={handleLoadAllTags}>
          Učitaj više
        </Button>
      ) : null}
    </Container>
  );
};

export { Tags };
